<script setup lang="ts">
import {useCarousel} from './useCarousel'
import {tw} from "../../../utils/tailwind";
import CarouselButton from "./CarouselButton.vue";
import type {HTMLAttributes} from "vue";

interface Props{
    svgClasses?: string
    class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
    svgClasses: "lg:!h-15 lg:!w-15",
})

const {orientation, canScrollNext, scrollNext, arrowColor, hoverArrowColor, outline, outlineColor} = useCarousel()
const strokeWidth = outline ? '0.6' : 0;

function next(e) {
    scrollNext()
}
</script>

<template>
    <CarouselButton
        :disabled="!canScrollNext"
        :class="tw(
      'touch-manipulation absolute',
      orientation === 'horizontal'
        ? 'right-4 top-1/2 -translate-y-1/2 lg:-right-12'
        : '-bottom-12 left-1/2 -translate-x-1/2 rotate-90',
      props.class,
    )"
        variant="outline"
        @click="next"
    >
        <slot>
            <div class="absolute group carouselNav" :style="'--hover-color:' + hoverArrowColor">
                <svg viewBox="0 0 36 38" xmlns="http://www.w3.org/2000/svg" :fill="arrowColor"
                     class="!w-7 !h-7 group-hover:fill-current" :class="svgClasses">
                    <path d="M1 10.5V1L35 15V22.5L1 37V27L20.5 19L1 10.5Z" :stroke-width="strokeWidth" :stroke="outlineColor"/>
                </svg>
                <span class="sr-only">Next Slide</span>
            </div>
        </slot>
    </CarouselButton>
</template>
